// Config for Voucher payout
export const voucherPayout = true;
export const voucherPremiumPercentage = process.env.REACT_APP_VOUCHER_PREMIUM_PERCENTAGE || 20;

// Config for price setting
export const userCanSetPrice = true;
